import { Link } from "@fluentui/react/lib/Link";

import { useBigUrlValueStyles } from "./UseBigUrlValueStyles";
import { ICommonUrlValueProps } from "../ICommonUrlValueProps";

export function BigUrlValue({ url, label, count }: ICommonUrlValueProps): JSX.Element {
  const styles = useBigUrlValueStyles();
  return (
    <Link className={styles.root} href={url} target="_blank">
      {`${label} ${count}`}
    </Link>
  );
}
